import { useEffect, RefObject } from 'react';

/**
 * Watches all [data-reveal] elements inside the given ref container
 * and adds the "is-visible" class when they enter the viewport.
 */
const useScrollReveal = (ref: RefObject<HTMLElement | null>, threshold = 0.08) => {
  useEffect(() => {
    const root = ref.current;
    if (!root) return;

    const els = root.querySelectorAll<HTMLElement>('[data-reveal]');
    if (!els.length) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold }
    );

    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [ref, threshold]);
};

export default useScrollReveal;
